import type { IasBrandSafetyKey, IasBrandSafetyValue } from "./types";

export const IAS_SCRIPT_URL = "//cdn.adsafeprotected.com/iasPET.1.js";
export const IAS_PUB_ID = "930616";

export const IAS_BRAND_SAFETY_KEYS: IasBrandSafetyKey[] = [
  "adt",
  "alc",
  "dlm",
  "drg",
  "hat",
  "off",
  "vio",
] as const;

export const IAS_BRAND_SAFETY_VALUES_LEVEL: Record<
  IasBrandSafetyValue,
  number
> = {
  veryLow: 1,
  low: 2,
  medium: 3,
  high: 4,
};

/**
 * All slots on all apps that Fandom has.
 *
 * NOTE: This is not exactly how it is supposed to be, but host currently mixes `platform` with `app`
 * The `ucp-desktop` and `ucp-mobile` are not platforms, but apps, but currently
 * in the `fandomHost.app` there's "fandomdesktop" and "fandommobile".
 * If that ever gets fixed, this code will need to be updated.
 */
export const IAS_WATCHED_SLOT_LIST: Record<string, string[]> = {
  default: [], // fallback
  fandomdesktop: [
    "top_leaderboard",
    "top_boxad",
    "incontent_boxad",
    "incontent_leaderboard",
    "bottom_leaderboard",
    "gallery_leaderboard",
    "featured",
    "incontent_player",
  ],
  fandommobile: [
    "top_leaderboard",
    "top_boxad",
    "incontent_boxad",
    "bottom_leaderboard",
    "featured",
    "incontent_player",
    "drawer",
  ],
  f2: [
    "top_leaderboard",
    "top_boxad",
    "incontent_boxad",
    "bottom_leaderboard",
    "featured",
  ],
  comicvine: ["mpu_top"],
  gamefaqs: ["mpu_top"],
  gamespot: ["mpu_top"],
  giantbomb: ["mpu_top"],
  metacritic: ["mpu_plus_top"],
  "metacritic-neutron": ["mpu-plus-top"],
  tvguide: ["mpu-plus-top"],
  sports: [
    "cdm-zone-01",
    "cdm-zone-02",
    "cdm-zone-03",
    "cdm-zone-04",
    "cdm-zone-06",
  ],
} as const;
